// Iter 51 — Centralised tooltip copy for the Dashboard metric labels.
// Extracted from Dashboard.jsx (was `const TIP`) so the dashboard render
// stays focused on layout.
export const DASHBOARD_TIPS = {
  profit_factor: {
    title: "Profit Factor",
    description: "Gross profit ÷ gross loss. Above 1.5 is healthy. Unreliable with very few trades.",
  },
  expectancy: {
    title: "Expectancy",
    description: "Your average ₹/$ gain per trade — your real, repeatable edge.",
  },
  avg_rr: {
    title: "Avg Risk:Reward",
    description: "For every ₹1 you risk, how much you typically make.",
  },
  max_drawdown: {
    title: "Max Drawdown",
    description: "Biggest dip from your account's peak. Closer to ₹0 is safer.",
  },
  sl_discipline: {
    title: "Stop Loss Discipline",
    description: "% of trades where you actually set a stop loss before entering.",
  },
  emotional_control: {
    title: "Emotional Control",
    description: "Your win rate right after a loss — flags revenge trading.",
  },
  exit_discipline: {
    title: "TP Hit Rate / Cut Early",
    description: "How often you let winners run to target vs exited early from fear.",
  },
  streak: {
    title: "Best / Worst Streak",
    description: "Longest run of consecutive wins or losses.",
  },
};
